import * as React from 'react';
const DeselectedIcon = require('./feature-deselected.png');
const SelectedIcon = require('./feature-selected.png');

export const FeaturedStar = ({ className, selected, onClick }) => {
  const src = selected ? SelectedIcon : DeselectedIcon;
  return <img src={src} onClick={onClick} className={className} />;
};
